import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Ferries from "../../RouteDescription/Ferries";

export default function FergeListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse &&
      props.roadFeatureResponse.ferger && 
      props.roadFeatureResponse.ferger.length !== 0 &&
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Ferger (${props.roadFeatureResponse?.ferger.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto"
        unmountOnExit 
        >
          <Ferries roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
        </>
      }
    </>
  )
}